export default {
  // YouTube Link Generator
  'link.mainTitle': 'Generator Link Timestamp YouTube',
  'link.mainTitleSEO': 'Generator Link Timestamp YouTube - Buat Link Video yang Dapat Dibagikan',
  'link.subtitle': 'Buat link YouTube yang dimulai pada waktu tertentu - sempurna untuk berbagi',

  // Link Generator Tool
  'link.generatorTitle': 'Buat Link YouTube dengan Timestamp',
  'link.pasteUrl': 'Tempel URL YouTube:',
  'link.urlPlaceholder': 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  'link.startTime': 'Waktu Mulai:',
  'link.hours': 'Jam',
  'link.minutes': 'Menit',
  'link.seconds': 'Detik',
  'link.orEnterSeconds': 'Atau masukkan total detik:',
  'link.secondsPlaceholder': 'misalnya, 90',

  // Output Section
  'link.generatedLinks': 'Link yang Dapat Dibagikan yang Dihasilkan:',
  'link.shortLink': 'Link Pendek (Direkomendasikan):',
  'link.fullLink': 'Link Lengkap:',
  'link.embedCode': 'Kode Embed:',
  'link.preview': 'Pratinjau:',
  'link.copyLink': 'Salin Link',
  'link.copyEmbed': 'Salin Embed',

  // URL Formats
  'link.urlFormats': 'Format URL Timestamp YouTube Dijelaskan',
  'link.format1Title': '1. Format Parameter Query (?t=)',
  'link.format1Desc': 'Tambahkan ?t= atau &t= ke URL YouTube mana pun:',
  'link.format1Example1': '?t=90 - 90 detik (1 menit 30 detik)',
  'link.format1Example2': '?t=1m30s - 1 menit 30 detik',
  'link.format1Example3': '?t=1h5m30s - 1 jam 5 menit 30 detik',

  'link.format2Title': '2. Format Fragmen Hash (#t=)',
  'link.format2Desc': 'Format lama menggunakan #t=:',

  'link.format3Title': '3. Deep Link Aplikasi Mobile',
  'link.format3Desc': 'Untuk berbagi mobile:',

  'link.format4Title': '4. URL Embed dengan Parameter Start',
  'link.format4Desc': 'Untuk video yang di-embed:',

  // Use Cases
  'link.useCases': 'Kapan Menggunakan Link Bertimestamp',
  'link.useCase1Title': '📱 Berbagi Media Sosial',
  'link.useCase1Desc': 'Bagikan momen tepat di Twitter, Facebook, Reddit',

  'link.useCase2Title': '📧 Referensi Email',
  'link.useCase2Desc': 'Kirim rekan kerja ke bagian spesifik dari video pelatihan',

  'link.useCase3Title': '📝 Kutipan Blog',
  'link.useCase3Desc': 'Link ke bukti video spesifik dalam artikel',

  'link.useCase4Title': '💬 Diskusi Forum',
  'link.useCase4Desc': 'Referensi momen tepat dalam debat video',

  'link.useCase5Title': '🎓 Konten Pendidikan',
  'link.useCase5Desc': 'Arahkan siswa ke segmen pelajaran tertentu',

  'link.useCase6Title': '🎬 Ulasan Video',
  'link.useCase6Desc': 'Sorot adegan atau momen tertentu',

  // FAQ
  'link.faq': 'FAQ Link Timestamp YouTube',

  'link.faq.q1': 'Apakah link timestamp YouTube berfungsi di ponsel?',
  'link.faq.a1': 'Ya! Format ?t= dan #t= berfungsi di browser mobile dan aplikasi YouTube. Link akan terbuka di aplikasi jika terpasang, atau di browser mobile.',

  'link.faq.q2': 'Bisakah saya menggunakan link timestamp di video yang di-embed?',
  'link.faq.a2': 'Ya, gunakan parameter start= di URL embed: <iframe src="https://www.youtube.com/embed/VIDEO_ID?start=90"></iframe>',

  'link.faq.q3': 'Apakah link timestamp berfungsi dengan YouTube Shorts?',
  'link.faq.a3': 'Tidak, YouTube Shorts saat ini tidak mendukung parameter timestamp. Link timestamp hanya berfungsi dengan video YouTube biasa.',

  'link.faq.q4': 'Apakah link timestamp akan selalu berfungsi?',
  'link.faq.a4': 'Ya, selama video tetap publik dan dapat diakses, link timestamp akan terus berfungsi. Jika video dihapus atau dibuat pribadi, link tidak akan berfungsi.',

  'link.faq.q5': 'Bisakah saya menambahkan waktu akhir ke link?',
  'link.faq.a5': 'Ya, Anda dapat menambahkan parameter &end=: ?t=90&end=180 akan memutar dari 1:30 hingga 3:00',

  'link.faq.q6': 'Format mana yang harus saya gunakan - ?t= atau #t=?',
  'link.faq.a6': 'Gunakan format ?t= (parameter query). Ini adalah standar modern dan berfungsi lebih andal di semua platform. Format #t= lebih lama dan kurang kompatibel.',

  // Related Tools
  'link.relatedTools': 'Alat YouTube Terkait',
  'link.needChapters': 'Perlu Membuat Chapter Video?',
  'link.needChaptersDesc': 'Gunakan Generator Timestamp YouTube kami untuk membuat timestamp chapter untuk deskripsi video dan komentar.',
  'link.checkGenerator': 'Lihat Generator Timestamp YouTube',

  'link.needUnixTime': 'Bekerja dengan Timestamp Unix?',
  'link.needUnixTimeDesc': 'Konversi timestamp Unix ke tanggal yang dapat dibaca dengan konverter timestamp kami.',

  // How to Use
  'link.howToUse': 'Cara Membuat Link Timestamp YouTube',
  'link.step1': 'Salin URL video YouTube',
  'link.step1Desc': 'Dapatkan URL dari bilah alamat browser atau tombol bagikan',

  'link.step2': 'Masukkan waktu mulai',
  'link.step2Desc': 'Gunakan pemilih waktu atau masukkan detik secara langsung',

  'link.step3': 'Salin format link pilihan Anda',
  'link.step3Desc': 'Pilih antara link pendek, link lengkap, atau kode embed',

  'link.step4': 'Bagikan di mana saja!',
  'link.step4Desc': 'Berfungsi di media sosial, email, forum, dan aplikasi pesan',

  // Additional Tips
  'link.tips': 'Tips Pro',
  'link.tip1': '💡 Gunakan link pendek (youtu.be) untuk media sosial - lebih bersih dan menghemat ruang',
  'link.tip2': '💡 Klik kanan pada video YouTube dan pilih "Salin URL video pada waktu saat ini" untuk berbagi cepat',
  'link.tip3': '💡 Timestamp berfungsi dengan playlist juga: cukup tambahkan &t=90 ke URL playlist',
  'link.tip4': '💡 Anda dapat menggabungkan dengan parameter lain seperti &list= untuk playlist atau &autoplay=1',
};
